import { render, staticRenderFns } from "./AncientSampleDetail.vue?vue&type=template&id=c36d43ca&scoped=true"
import script from "./AncientSampleDetail.vue?vue&type=script&lang=js"
export * from "./AncientSampleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36d43ca",
  null
  
)

export default component.exports